import { render, staticRenderFns } from "./ObjectContactsBulkAction.vue?vue&type=template&id=45142611&scoped=true"
import script from "./ObjectContactsBulkAction.vue?vue&type=script&lang=js"
export * from "./ObjectContactsBulkAction.vue?vue&type=script&lang=js"
import style0 from "./ObjectContactsBulkAction.vue?vue&type=style&index=0&id=45142611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45142611",
  null
  
)

export default component.exports